var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "jeecg-editor-ty",
      class: _vm.fullCoder ? "jeecg-editor-max" : "jeecg-editor-min",
    },
    [
      _vm.fullScreen
        ? _c("a-icon", {
            staticClass: "full-screen-icon",
            attrs: { type: _vm.iconType },
            on: { click: () => (_vm.fullCoder = !_vm.fullCoder) },
          })
        : _vm._e(),
      _c("textarea", { attrs: { id: _vm.dynamicId } }),
      _c(
        "span",
        {
          staticClass: "null-tip",
          class: { "null-tip-hidden": _vm.hasCode },
          style: _vm.nullTipStyle,
          on: { click: _vm.nullTipClick },
        },
        [_vm._v(_vm._s(_vm.placeholderShow))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }